import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationBarComponent } from "projects/declarabid-private/src/app/shared/components/navigation-bar/navigation-bar.component";
import { BreadcrumbModule } from "primeng/breadcrumb";

@Component({
    selector: 'app-teacher',
    imports: [NavigationBarComponent, BreadcrumbModule, RouterOutlet],
    templateUrl: './teacher.component.html',
    styleUrl: './teacher.component.scss'
})
export class TeacherComponent {

}
